<template>
  <div class="progress-report">
    <v-card>
      <v-card-title>
        <h3>Báo cáo tiến độ</h3>
      </v-card-title>
      <v-card-text>
        <v-layout wrap align-center style="padding: 10px 0;">
          <v-flex v-if="isAdmin" xs3 style="padding-right: 10px;">
            <v-select
                :items="provinceUsers"
                label="Tỉnh/Thành phố"
                v-model="selectedProvinceId"
                item-text="fullName"
                item-value="userId"
                clearable
            ></v-select>
          </v-flex>

          <v-flex xs3 style="padding-right: 10px;">
            <v-text-field
               
                label="Trường"
                v-model="schoolName"
                type="input"
               
            ></v-text-field>
          </v-flex>

          <v-flex xs3 style="padding-right: 10px;">
            <v-menu
                ref="startMenu"
                v-model="startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="startDate"
                    label="Từ ngày"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="startDate"
                  no-title
                  scrollable
                  @input="startMenu = false; validateDates()"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs3>
            <v-menu
                ref="endMenu"
                v-model="endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="endDate"
                    label="Đến ngày"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="endDateError"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="endDate"
                  no-title
                  scrollable
                  :min="startDate"
                  @input="endMenu = false; validateDates()"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 style="padding-top: 10px;">
            <v-btn color="primary" @click="fetchProgressReport(true)" :disabled="!!endDateError">
              <v-icon left>mdi-magnify</v-icon>
              Tìm kiếm
            </v-btn>
            <v-btn color="success" @click="exportExcel" :disabled="!!endDateError" :loading="exporting" style="margin-left: 10px;">
              <v-icon left>mdi-file-excel</v-icon>
              Export Excel
            </v-btn>
          </v-flex>
        </v-layout>
        <v-data-table
            :headers="headers"
            :items="progressReports"
            :loading="loading"
            item-key="reportId"
            :rows-per-page-items="[10, 20, 50, 100]"
            :pagination.sync="pagination"
            :total-items="totalItems"
            loading-text="Loading... Please wait"
            class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.schoolIndex }}</td>
            <td>{{ props.item.schoolName || '-' }}</td>
            <td>{{ props.item.className || '-' }}</td>
            <td>{{ formatDateTime(props.item.classCreatedAt) }}</td>
            <td>{{ props.item.totalLessonCompleteLv1 || 0 }}/{{ props.item.totalLessonLv1 }} lessons</td>
            <td>{{ props.item.totalLessonCompleteLv2 || 0 }}/{{ props.item.totalLessonLv2 }} lessons</td>
            <td>{{ props.item.totalLessonCompleteLv3 || 0 }}/{{ props.item.totalLessonLv3 }} lessons</td>
            <td>{{ formatDateTimeFromTimestamp(props.item.lastTime) }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { fetchProgressReportData, exportProgressReportExcel } from '@/api/progressReportAPI';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'ProgressReport',
  data () {
    return {
      startMenu: false,
      endMenu: false,
      startDate: this.getDefaultStartDate(),
      endDate: this.getDefaultEndDate(),
      selectedProvinceId: null,
      schoolName: null,
      provinceUsers: [],
      progressReports: [],
      loading: false,
      exporting: false,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      totalItems: 0,
      endDateError: '',
      headers: [
        { text: 'STT', value: 'index', sortable: false },
        { text: 'Trường', value: 'schoolName', sortable: true },
        { text: 'Lớp', value: 'className', sortable: true },
        { text: 'Thời gian tạo tài khoản lớp', value: 'classCreatedAt', sortable: true },
        { text: 'Hoàn thành Level 1', value: 'rateLv1', sortable: true },
        { text: 'Hoàn thành Level 2', value: 'rateLv2', sortable: true },
        { text: 'Hoàn thành Level 3', value: 'rateLv3', sortable: true },
        { text: 'Ngày học cuối cùng', value: 'lastTime', sortable: true },
      ]
    }
  },
  watch: {
    pagination: {
      handler(newVal, oldVal) {
        // Chỉ fetch khi pagination thay đổi bởi user (không phải lúc mount hoặc khi đang loading)
        if (!this.loading && oldVal && oldVal.page !== undefined && 
            (newVal.page !== oldVal.page || newVal.rowsPerPage !== oldVal.rowsPerPage)) {
          console.log("Pagination changed by user:", { old: oldVal, new: newVal });
          this.fetchProgressReport(false); // false = không reset page
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.auth.user,
      roleList: state => state.role.roleList
    }),
    isAdmin() {
      // Check nếu user có roleName = "ADMIN"
      if (!this.currentUser || !this.currentUser.role) {
        console.log('isAdmin: No currentUser or role');
        return false;
      }
      
      // Nếu roleList chưa được load
      if (!this.roleList || this.roleList.length === 0) {
        console.log('isAdmin: roleList not loaded yet');
        return false;
      }
      
      // Tìm role có roleName = "ADMIN" (case-insensitive)
      const adminRole = this.roleList.find(role => 
        role.roleName && role.roleName.toUpperCase() === 'ADMIN'
      );
      
      console.log('isAdmin check:', {
        currentUserRole: this.currentUser.role,
        roleList: this.roleList,
        adminRole: adminRole
      });
      
      if (adminRole && adminRole.id) {
        // So sánh role ID (convert về cùng type)
        const userRoleId = Number(this.currentUser.role);
        const adminRoleId = Number(adminRole.id);
        const isAdmin = userRoleId === adminRoleId;
        console.log('isAdmin result:', isAdmin, 'userRoleId:', userRoleId, 'adminRoleId:', adminRoleId);
        return isAdmin;
      }
      
      console.log('isAdmin: Admin role not found in roleList');
      return false;
    }
  },
  methods: {
    getDefaultStartDate() {
      // Trả về ngày hiện tại - 1 (hôm qua)
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday.toISOString().split('T')[0];
    },
    getDefaultEndDate() {
      // Trả về ngày hiện tại - 1 (hôm qua)
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday.toISOString().split('T')[0];
    },
    validateDates() {
      this.endDateError = '';
      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);
        if (end < start) {
          this.endDateError = 'Đến ngày không được nhỏ hơn Từ ngày';
          return false;
        }
      }
      return true;
    },
    async fetchProgressReport(resetPage = false) {
      // Validate dates trước khi fetch
      if (!this.validateDates()) {
        return;
      }
      
      // Nếu resetPage = true (khi user click search), reset về page 1 và clear map
      if (resetPage) {
        this.pagination.page = 1;
      }
      
      this.loading = true;

      try {
        // Lấy page và pageSize từ pagination state
        const page = this.pagination.page || 1;
        const pageSize = this.pagination.rowsPerPage || 10;
        const domain = window.location.hostname;
        const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
        
        console.log("Before fetchProgressReportData call", { page, pageSize, product });
        const response = await fetchProgressReportData(this.startDate, this.endDate, this.schoolName, this.selectedProvinceId, page, pageSize, product);
        console.log("After fetchProgressReportData call");
        console.log("res", response);
        console.log("res type:", typeof response);

        // API trả về Page object với structure: { content: [], totalElements: number, totalPages: number, ... }
        if (response && response.content) {
          // Response là Page object từ Spring Data
          console.log("Setting progressReports from Page object");
          console.log("Content length:", response.content.length);
          console.log("Total elements:", response.totalElements);
          console.log("Total pages:", response.totalPages);
          console.log("Current page (0-based):", response.number);
          console.log("Is last page:", response.last);
          
          // // Cập nhật map với schoolName mới từ page hiện tại
          // let counter = Math.max(...Object.values(this.schoolNameToNumberMap), 0) + 1;
          // response.content.forEach(report => {
          //   const schoolName = report.schoolName || '-';
          //   if (!this.schoolNameToNumberMap[schoolName]) {
          //     this.schoolNameToNumberMap[schoolName] = counter++;
          //   }
          // });
          
          this.progressReports = [...response.content];
          // Đảm bảo totalItems được set từ totalElements
          this.totalItems = response.totalElements ? Number(response.totalElements) : 0;
          
          // Cập nhật pagination state từ response để đồng bộ
          if (response.number !== undefined) {
            this.pagination.page = response.number + 1; // Convert từ 0-based sang 1-based
          }
          if (response.size !== undefined) {
            this.pagination.rowsPerPage = response.size;
          }
          
          console.log("progressReports after setting:", this.progressReports.length);
          console.log("totalItems set to:", this.totalItems);
          console.log("pagination state:", this.pagination);
          console.log("schoolNameToNumberMap:", this.schoolNameToNumberMap);
        } else if (Array.isArray(response)) {
          // Fallback: nếu response là array (backward compatibility)
          console.log("Response is array (fallback)");
          this.progressReports = [...response];
          this.totalItems = response.length;
        } else {
          console.warn('Response format not recognized:', response);
          this.progressReports = [];
          this.totalItems = 0;
        }
      } catch (error) {
        console.log('Lỗi khi tải báo cáo tiến độ:', error);
        console.error('Error details:', error);
        this.progressReports = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
      }
    },
    async exportExcel() {
      if (!this.validateDates()) {
        return;
      }
      this.exporting = true;
      try {
        const page = this.pagination.page || 1;
        const pageSize = this.pagination.rowsPerPage || 10;
        const domain = window.location.hostname;
        const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
        const response = await exportProgressReportExcel(this.startDate, this.endDate, this.schoolName, this.selectedProvinceId, page, pageSize, product);
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'BaoCaoTienDo.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error('Lỗi khi xuất Excel:', error);
      } finally {
        this.exporting = false;
      }
    },
    getCompletionRateColor(rate) {
      if (rate === null || rate === undefined) return 'grey';
      if (rate >= 80) return 'green';
      if (rate >= 50) return 'orange';
      return 'red';
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('vi-VN');
    },
    formatDateTime(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    formatDateTimeFromTimestamp(timestamp) {
      if (!timestamp) return 'N/A';
      // lastTime là Long timestamp (milliseconds), convert sang Date
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return 'N/A';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    loadProvinceUsers() {
      axios.get(`${process.env.VUE_APP_API_URL}/user/provinces`)
        .then(response => {
          // Interceptor đã trả về response.data, nên response ở đây đã là data array
          this.provinceUsers = Array.isArray(response) ? response : [];
        })
        .catch(error => {
          console.error('Error loading province users:', error);
          this.provinceUsers = [];
        });
    }
  },
  mounted() {
    this.$store.dispatch("role/getRoleList");
    this.loadProvinceUsers();
    this.fetchProgressReport();
  }
}
</script>

<style scoped>
.progress-report {
  padding: 20px;
}
</style>